import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isObjEmpty } from 'utils/varValidation';

// Components
import Media from 'react-media';
import { Icon } from 'components/atoms/Icon/';
import PackagesTable from 'components/molecules/PackagesTable';
import PackagesTableMobile from 'components/molecules/PackagesTableMobile';

// Utils
import { calcPackageTotalPrice } from 'utils/prices';

// Enums
import { APP_BREAKPOINTS } from 'constants/appConfig';

import './PackagesModal.scss';

const ns = 'packages-modal';

class PackagesModal extends Component {
  constructor(props) {
    super(props);
    this.selectService = this.selectService.bind(this);
    this.clickHandler = this.clickHandler.bind(this);
    this.toggleActiveTab = this.toggleActiveTab.bind(this);
    this.canUpdatePackage = this.canUpdatePackage.bind(this);
    this.state = {
      activeTab: null,
      packages: [],
      hardReset: false,
      canUpdate: false
    };
  }

  componentDidMount() {
    this.resetPackages();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.apptServicePoint !== this.props.apptServicePoint) {
      this.setState({ hardReset: true });
    }
  }

  componentDidUpdate() {
    if (this.state.hardReset) {
      this.resetPackages();
      /* eslint-disable react/no-did-update-set-state */
      this.setState({ hardReset: false });
      /* eslint-enable react/no-did-update-set-state */
    }
  }

  resetPackages() {
    const {
      packages,
      apptServicePoint,
      servicesExpanded,
      readOnlyPackage
    } = this.props;
    this.setState({
      activeTab: null,
      packages: packages.map(pack => {
        let services;
        if (apptServicePoint && pack.name === apptServicePoint.menuType.name) {
          const {
            menuType: { services: apptServices }
          } = apptServicePoint;
          services = pack.services.map(service => {
            if (
              apptServices.some(apptService => apptService.id === service.id)
            ) {
              return { ...service, isSelected: true };
            } else {
              return { ...service, isSelected: false };
            }
          });
        } else {
          services = pack.services.map(service => {
            return {
              ...service,
              isSelected: service.selectByDefault || !service.selectable,
              isExpanded: servicesExpanded
            };
          });
        }
        const totalPrice = calcPackageTotalPrice(services, pack.totalPrice);
        const isQuotedPackage =
          readOnlyPackage.id === pack.id || readOnlyPackage.name === pack.name;
        const updatedPackagePrice =
          readOnlyPackage.price || readOnlyPackage.totalPrice;
        return {
          ...pack,
          price: totalPrice,
          services,
          ...(isQuotedPackage
            ? {
                quoteServiceId: readOnlyPackage.quoteServiceId,
                price: updatedPackagePrice,
                totalPrice: updatedPackagePrice
              }
            : {})
        };
      })
    });
  }

  selectService(serviceId, packageIndex) {
    const { activePromotion } = this.props;
    this.setState(
      {
        packages: this.state.packages.map((pack, index) => {
          const services = pack.services.map(service => {
            return {
              ...service,
              isSelected:
                service.id === serviceId && packageIndex === index
                  ? !service.isSelected
                  : service.isSelected
            };
          });
          const totalPrice = calcPackageTotalPrice(services, pack.totalPrice);
          const resultingPackage = {
            ...pack,
            price: totalPrice,
            services
          };
          if (activePromotion) {
            resultingPackage.discountedPrice = calcPackageTotalPrice(
              resultingPackage.services,
              resultingPackage.totalPrice,
              activePromotion
            );
          }
          return resultingPackage;
        })
      },
      () => this.canUpdatePackage(packageIndex)
    );
  }

  canUpdatePackage(packageIndex) {
    const { apptMenuType } = this.props;
    const { packages } = this.state;
    const modifiedPackage = packages.find(
      (pack, index) => pack.name === apptMenuType.name && index === packageIndex
    );
    if (!isObjEmpty(apptMenuType) && modifiedPackage) {
      const modifiedServices = packages
        .find(pack => pack.name === apptMenuType.name)
        .services.filter(service => service.isSelected);
      const modifiedServicesIds = modifiedServices.map(service => service.id);
      const selectedServicesIds = apptMenuType.services.map(
        service => service.id
      );
      if (
        JSON.stringify(modifiedServicesIds.sort()) !==
        JSON.stringify(selectedServicesIds.sort())
      ) {
        this.setState({ canUpdate: true });
      } else {
        this.setState({ canUpdate: false });
      }
    }
  }

  clearModal() {
    this.resetPackages();
    this.props.closeModal();
  }

  clickHandler(servicePackage) {
    const {
      setApptServicePoint,
      servicePoint,
      selectedPackage,
      updateReadOnlyPackage
    } = this.props;
    const { canUpdate } = this.state;
    const { menuTypes, ...servicePointProps } = servicePoint;
    const { services, id, rank, selectAll, ...packageProps } = servicePackage;
    const addedServices = services.filter(service => service.isSelected);
    const addedServicePoint = {
      ...servicePointProps,
      menuType: {
        ...packageProps,
        services: addedServices.map(service => {
          const { isSelected, isExpanded, salesTax, ...serviceProps } = service;
          return { ...serviceProps };
        })
      }
    };

    const isQuotedPackage = !!servicePackage.quoteServiceId;

    if (servicePackage.description !== selectedPackage || canUpdate) {
      setApptServicePoint(addedServicePoint);
      if (canUpdate) {
        this.setState({ canUpdate: false });
      }

      updateReadOnlyPackage(!!isQuotedPackage);
    } else {
      setApptServicePoint(null);
      if (isQuotedPackage) {
        updateReadOnlyPackage(false);
      }
    }
    this.props.closeModal();
  }

  toggleActiveTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: 'spinner'
      });
      setTimeout(() => {
        this.setState({
          activeTab: tab
        });
      }, 900);
    }
  }

  render() {
    const {
      selectedPackage,
      activePackage,
      activePromotion,
      intl,
      readOnlyPackage
    } = this.props;
    const { packages, activeTab: stateActiveTab, canUpdate } = this.state;
    const activeTab =
      stateActiveTab ||
      activePackage ||
      selectedPackage ||
      (packages.length > 0 ? packages[0].description : null);
    const { SM } = APP_BREAKPOINTS;

    const isReadOnly = false;

    return (
      <div className={ns} aria-modal={true}>
        <div>
          <h2 className={`${ns}__title modal__title`}>
            {intl.formatMessage({
              id: 'c8.services.page.packages.modal.title'
            })}
          </h2>
          <button
            className={`${ns}__close modal__close`}
            onClick={() => this.clearModal()}
            tabIndex={0}
            aria-label={intl.formatMessage({
              id: 'c8.aria.close.package.modal',
              defaultMessage: 'Close Packages Modal'
            })}
          >
            <Icon type="close" />
          </button>
        </div>

        <Media query={`(max-width: ${SM}px)`}>
          {matches =>
            matches ? (
              <PackagesTableMobile
                packages={packages}
                quoteServices={readOnlyPackage && readOnlyPackage.services}
                selectService={this.selectService}
                selectedPackage={selectedPackage}
                addPackage={this.clickHandler}
                toggleActiveTab={this.toggleActiveTab}
                activeTab={activeTab}
                canUpdate={canUpdate}
                readOnly={isReadOnly && !isObjEmpty(isReadOnly)}
              />
            ) : (
              <PackagesTable
                packages={packages}
                quoteServices={readOnlyPackage && readOnlyPackage.services}
                selectService={this.selectService}
                addPackage={this.clickHandler}
                selectedPackage={selectedPackage}
                promotion={activePromotion}
                canUpdate={canUpdate}
                activePackage={activePackage}
                readOnly={isReadOnly && !isObjEmpty(isReadOnly)}
              />
            )
          }
        </Media>
      </div>
    );
  }
}

PackagesModal.propTypes = {
  activePackage: PropTypes.string,
  activePromotion: PropTypes.object,
  apptMenuType: PropTypes.object,
  apptServicePoint: PropTypes.object,
  closeModal: PropTypes.func.isRequired,
  intl: PropTypes.object,
  packages: PropTypes.array.isRequired,
  selectedPackage: PropTypes.string,
  servicePoint: PropTypes.object,
  servicesExpanded: PropTypes.bool,
  setApptServicePoint: PropTypes.func.isRequired,
  isQuoteAppt: PropTypes.bool.isRequired,
  readOnlyPackage: PropTypes.object,
  updateReadOnlyPackage: PropTypes.func.isRequired
};

export default PackagesModal;



// WEBPACK FOOTER //
// ./src/components/molecules/PackagesModal/PackagesModal.js